export default "__VITE_ASSET__C_L9NPEs__"